import { render, staticRenderFns } from "./StatementListDetail.vue?vue&type=template&id=388c1e2c&scoped=true"
import script from "./StatementListDetail.vue?vue&type=script&lang=js"
export * from "./StatementListDetail.vue?vue&type=script&lang=js"
import style0 from "./StatementListDetail.vue?vue&type=style&index=0&id=388c1e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c1e2c",
  null
  
)

export default component.exports